import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "Microscope",
    image: "Microscope",
    type: "interactableObject",
    defaultState: "unplugged",
    states: [
      {
        name: "unplugged",
        image: "MicroscopeNoSlide",
        altText: "Light microscope with no slide inserted",
      },
      {
        name: "plugged",
        image: "MicroscopeNoSlide",
        altText: "Light microscope with no slide inserted",
      },
      {
        name: "slideInserted",
        image: "MicroscopeSlide",
        altText: "Light microscope with slide inserted",
      },
      {
        name: "slide2Inserted",
        image: "MicroscopeSlide",
        altText: "Light microscope with second slide inserted",
      },
      {
        name: "slideEjected",
        image: "MicroscopeNoSlide",
        altText: "Light microscope with no slide inserted",
      },
      {
        name: "wiped",
        image: "MicroscopeNoSlide",
        altText: "Light microscope with no slide inserted",
      },
      {
        name: "lowered",
        image: "MicroscopeNoSlide",
        altText: "Light microscope with no slide inserted",
      },
      {
        name: "rotateToLowest",
        image: "MicroscopeNoSlide",
        altText: "Light microscope with no slide inserted",
      },
    ],
  },
  {
    name: "MysterySlideZ",
    image: "MysterySlideZ",
    defaultState: "placedOnRack",
    type: "interactableObject",
    states: [
      {
        name: "placedOnRack",
        image: "MysterySlideZ",
      },
      {
        name: "ejected",
        image: "",
      },
    ],
  },
  {
    name: "MysterySlideY",
    image: "MysterySlideY",
    defaultState: "placed",
    type: "controllableObject",
    states: [
      {
        name: "placed",
        image: "",
      },
      {
        name: "ejected",
        image: "MysterySlideY",
      },
      {
        name: "slide2Ejected",
        image: "MysterySlideY",
      },
      {
        name: "slide2DroppedOnMicroscope",
        image: "",
      },
      {
        name: "droppedOnMicroscope",
        image: "",
      },
    ],
  },
  {
    name: "MicroscopeWipes",
    image: "MicroscopeWipes",
    type: "interactableObject",
    states: [],
  },
  {
    name: "SlideRack",
    image: "SlideRack",
    type: "interactableObject",
    states: [],
  },
  {
    name: "EjectSlide",
    image: "EjectSlide",
    type: "interactableObject",
    states: [],
  },
  {
    name: "MicroscopeSwitch",
    image: "MicroscopeSwitchOff",
    type: "interactableObject",
    states: [
      {
        name: "off",
        image: "MicroscopeSwitchOff",
      },
      {
        name: "on",
        image: "MicroscopeSwitchOn",
      },
    ],
  },
  {
    name: "LampLight",
    image: "MicroscopeLampLight",
    type: "interactableObject",
    defaultState: "Off",
    states: [
      {
        name: "off",
        image: "",
      },
      {
        name: "on",
        image: "MicroscopeLampLight",
      },
    ],
  },
  {
    name: "MicroscopeWipe",
    image: "Wipe",
    type: "controllableObject",
    defaultState: "boxed",
    states: [
      {
        name: "boxed",
        image: "",
      },
      {
        name: "ejected",
        image: "Wipe",
      },
      {
        name: "dropped",
        image: "",
      },
    ],
  },
  {
    name: "WipeModal",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "ThumbnailModal",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "UnplugModal",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "SorterView",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "LenseAnimation1",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "LenseAnimation2",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "LenseAnimation3",
    image: "",
    type: "interactableObject",
    states: [],
  },
  {
    name: "LightIntensity",
    image: "",
    type: "interactableObject",
    defaultState: "static",
    states: [
      {
        name: "static",
        image: "",
      },
      {
        name: "adjusted",
        image: "",
      },
    ],
  },
  {
    name: "Stage",
    image: "",
    type: "interactableObject",
    defaultState: "right",
    states: [
      {
        name: "right",
        image: "",
      },
      {
        name: "centered",
        image: "",
      },
    ],
  },
  {
    name: "IdealMicroscopeBlur",
    image: "",
    type: "interactableObject",
    defaultState: "rough",
    states: [
      {
        name: "rough",
        image: "",
      },
      {
        name: "passed",
        image: "",
      },
    ],
  },
  {
    name: "Coarse",
    image: "",
    type: "interactableObject",
    defaultState: "centered",
    states: [
      {
        name: "centered",
        image: "",
      },
      {
        name: "lowered",
        image: "",
      },
      {
        name: "rough",
        image: "",
      },
    ],
  },
  {
    name: "Lens",
    image: "",
    type: "interactableObject",
    defaultState: "10x",
    states: [
      {
        name: "10x",
        image: "",
      },
      {
        name: "2.5x",
        image: "",
      },
      {
        name: "40x",
        image: "",
      },
    ],
  },
  {
    name: "FineFocus",
    image: "",
    type: "interactableObject",
    defaultState: "rough",
    states: [
      {
        name: "rough",
        image: "",
      },
      {
        name: "focused",
        image: "",
      },
      {
        name: "focused_10x",
        image: "",
      },
      {
        name: "focused_40x",
        image: "",
      },
    ],
  },
  {
    name: "Camera",
    image: "",
    type: "interactableObject",
    defaultState: "disabled",
    states: [
      {
        name: "disabled",
        image: "",
      },
      {
        name: "captured",
        image: "",
      },
      {
        name: "captured_10x",
        image: "",
      },
      {
        name: "captured_40x",
        image: "",
      },
    ],
  },
  {
    name: "MicroscopeModal",
    type: "interactableObject",
    image: "",
    defaultState: "closed",
    states: [
      {
        name: "closed",
        image: "",
      },
    ],
  },
];

export default objects;
